import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// SYSTEMONE
import BaseMixer from "../../BaseMixer";
import simplebar from "simplebar-vue";
import { ProjectMemberCreationModel } from "@/store/models/project/projectMemberCreation";
let EmployeeUserComponent = /** @class */ (() => {
    var _a;
    let EmployeeUserComponent = class EmployeeUserComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.searchKey = "";
            this.filteredUsers = [];
        }
        addUser(employeeId) {
            this.validate("employeeUserObserver").then((res) => {
                if (res) {
                    this.projectMember.employeeId = employeeId;
                }
                return this.save();
            });
        }
        cancelUser() {
            this.searchKey = "";
            return this.cancel();
        }
        searchUser() {
            this.filteredUsers = this.users.filter((item) => item.fullName.toLowerCase().includes(this.searchKey.toLowerCase()));
        }
        save() { }
        cancel() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], EmployeeUserComponent.prototype, "users", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof ProjectMemberCreationModel !== "undefined" && ProjectMemberCreationModel) === "function" ? _a : Object)
    ], EmployeeUserComponent.prototype, "projectMember", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], EmployeeUserComponent.prototype, "title", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], EmployeeUserComponent.prototype, "employeeId", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EmployeeUserComponent.prototype, "save", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EmployeeUserComponent.prototype, "cancel", null);
    EmployeeUserComponent = __decorate([
        Component({
            name: "EmployeeUserComponent",
            components: {
                simplebar,
            },
        })
    ], EmployeeUserComponent);
    return EmployeeUserComponent;
})();
export default EmployeeUserComponent;
